var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00153 11.9998C2.00153 6.91186 4.90417 2.56348 9.00155 0.817871C13.0989 2.56348 16.0016 6.91186 16.0016 11.9998C16.0016 12.8227 15.9256 13.6263 15.781 14.4026L17.7214 16.2352C17.8865 16.3911 17.9258 16.6388 17.817 16.8381L15.3216 21.4132C15.1892 21.6556 14.8856 21.7449 14.6432 21.6127C14.6013 21.5898 14.5628 21.5611 14.5291 21.5273L12.2945 19.2927C12.1069 19.1052 11.8526 18.9998 11.5874 18.9998H6.41574C6.15052 18.9998 5.89617 19.1052 5.70863 19.2927L3.47404 21.5273C3.27878 21.7226 2.9622 21.7226 2.76693 21.5273C2.73317 21.4935 2.70441 21.4551 2.68154 21.4132L0.186071 16.8381C0.0773213 16.6388 0.116591 16.3911 0.281701 16.2352L2.22209 14.4026C2.07746 13.6263 2.00153 12.8227 2.00153 11.9998ZM3.47737 18.6955L4.29442 17.8785C4.85703 17.3159 5.62009 16.9998 6.41574 16.9998H11.5874C12.383 16.9998 13.1461 17.3159 13.7087 17.8785L14.5257 18.6955L15.5076 16.8954L14.4078 15.8566C13.9137 15.39 13.6904 14.7044 13.8148 14.0363C13.9386 13.3721 14.0016 12.691 14.0016 11.9998C14.0016 8.13025 12.0065 4.69953 9.00155 3.04021C5.99657 4.69953 4.00153 8.13025 4.00153 11.9998C4.00153 12.691 4.0645 13.3721 4.18826 14.0363C4.31273 14.7044 4.08941 15.39 3.59533 15.8566L2.49548 16.8954L3.47737 18.6955ZM9.00155 11.9998C7.89695 11.9998 7.00153 11.1044 7.00153 9.9998C7.00153 8.89525 7.89695 7.99982 9.00155 7.99982C10.1061 7.99982 11.0016 8.89525 11.0016 9.9998C11.0016 11.1044 10.1061 11.9998 9.00155 11.9998Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.081e6696b38137af0d16448ca118d5e6.svg";
export { ForwardRef as ReactComponent };